<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12" v-if="organMode">
            <div class="form-group">
              <label>Уровень управления</label>
              <Select2
                @keyup.enter="apply"
                class="select2"
                :options="districtTypeList"
                placeholder="Не выбрано"
                v-model="currFilters.districtType"
                style="width: 100%"
                v-on:select="changeDistrictType"
              />
            </div>
          </div>
          <div
            class="col-md-12"
            v-if="!organMode || currFilters.districtType == 2"
          >
            <div class="form-group">
              <label>Муниципальные районы (городские округа)</label>
              <Select2
                @keyup.enter="apply"
                class="select2"
                :options="districtList"
                multiple="multiple"
                placeholder="Не выбрано"
                :settings="{ multiple: true }"
                v-model="currFilters.districtIds"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Наименование организации</label>
              <div>
                <input
                  class="form-control"
                  @keyup.enter="apply"
                  placeholder="Введите название"
                  v-model="currFilters.name"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>ИНН</label>
              <div>
                <input
                  class="form-control"
                  @keyup.enter="apply"
                  v-model="currFilters.inn"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label v-if="organMode">Сфера управления</label>
              <label v-else>Вид деятельности</label>
              <Select2
                @keyup.enter="apply"
                class="select2"
                :options="kindActivityList"
                placeholder="Не выбрано"
                v-model="currFilters.kindActivityId"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="col-md-12" v-if="!organMode">
            <div class="form-group">
              <label>Тип учреждения</label>
              <Select2
                @keyup.enter="apply"
                class="select2"
                :options="organizationTypeList"
                placeholder="Не выбрано"
                v-model="currFilters.organizationTypeId"
                v-on:select="loadOrganizationSubtypeList()"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="col-md-12" v-if="!organMode">
            <div class="form-group">
              <label>Вид учреждения</label>
              <Select2
                @keyup.enter="apply"
                class="select2"
                :options="organizationSubtypeList"
                placeholder="Не выбрано"
                v-model="currFilters.organizationSubtypeId"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="col-md-12" v-if="!organMode">
            <div class="form-group">
              <label>Организационно-правовая форма</label>
              <Select2
                @keyup.enter="apply"
                class="select2"
                :options="opfList"
                multiple="multiple"
                placeholder="Не выбрано"
                :settings="{ multiple: true }"
                v-model="currFilters.opfIds"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="col-md-12" v-if="!organMode">
            <div class="form-group">
              <label>Оказываемые услуги</label>
              <Select2
                @keyup.enter="apply"
                class="select2"
                :options="serviceTypeList"
                placeholder="Не выбрано"
                v-model="currFilters.serviceTypeId"
                style="width: 100%"
              />
            </div>
          </div>

          <div v-if="adminMode" class="col-md-12">
            <div class="form-group">
              <label>Роли</label>
              <Select2
                @keyup.enter="apply"
                class="select2"
                :options="roleList"
                multiple="multiple"
                :settings="{ multiple: true, language: 'ru' }"
                v-model="currFilters.roleIds"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>ОГРН</label>
              <div>
                <input
                  class="form-control"
                  @keyup.enter="apply"
                  v-model="currFilters.ogrn"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12" v-if="!organMode">
            <div class="form-group">
              <label>Дата регистрации в реестре</label>
              <div class="bottom-datepicker">
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.dateRegistration"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12" v-if="!organMode">
            <div class="form-group">
              <label>Дата последних изменений</label>
              <div class="bottom-datepicker">
                <date-component
                  @keyupEnter="apply"
                  v-model="currFilters.dateLastChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer justify-content-between border-0 bg-white d-flex">
        <button-component @click="apply" class="col-6"
          >Применить</button-component
        >
        <button-component kind="secondary" @click="reset" class="col-6"
          >Сбросить</button-component
        >
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../../common/constants";
import DateComponent from "@/common/components/DateComponent";
import Utils from "../../../common/utils";
import RoleApi from "../../admin/api/roles";
import ButtonComponent from "@/common/ui/ButtonComponent";

export default {
  name: "OrganizationsFilter",
  components: { ButtonComponent, DateComponent },
  props: {
    filters: Object,
    organMode: {
      type: Boolean,
      default: false,
    },
    adminMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      districtList: [],
      kindActivityList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      serviceTypeList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      opfList: [{ id: 0, selected: true }],
      organizationTypeList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      organizationSubtypeList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      currFilters: this.filters,
      roleList: [],
      districtTypeList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
        { id: 1, text: "региональный" },
        { id: 2, text: "муниципальный" },
      ],
    };
  },
  methods: {
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        districtType: 0,
        districtIds: [],
        serviceTypeId: 0,
        kindActivityId: 0,
        name: "",
        ogrn: "",
        dateRegistration: null,
        dateLastChange: null,
        opfIds: [],
        inn: "",
        organizationTypeId: 0,
        organizationSubtypeId: 0,
        roleIds: [],
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
    loadOrganizationSubtypeList() {
      Utils.loadSelectOptions(
        "organizationSubtype",
        this.organizationSubtypeList,
        { typeId: this.currFilters.organizationTypeId },
        true
      );
    },
    loadRoleList() {
      RoleApi.search({ pageNumber: 1, pageSize: -1 }).then((response) => {
        this.roleList = response.data.items.map((item) => ({
          id: item.id,
          text: item.name,
        }));
      });
    },

    changeDistrictType() {
      if (this.organMode) {
        if (this.currFilters.districtType != 2)
          this.currFilters.districtIds = [];
      }
    },
  },
  created() {
    Utils.loadSelectOptions("district", this.districtList);
    Utils.loadSelectOptions("serviceType", this.serviceTypeList);
    Utils.loadSelectOptions("opf", this.opfList, { parentId: 0 });
    Utils.loadSelectOptions("organizationType", this.organizationTypeList);
    Utils.loadSelectOptions("kindActivity", this.kindActivityList);
    this.loadOrganizationSubtypeList();
    this.loadRoleList();
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.select2::v-deep {
  .select2-container {
    width: 100%;
  }

  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;
  }

  .select2-container--default
    .select2-selection--single
    .select2-selection__arrow {
    top: 7px !important;
  }
}
.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}
h4 {
  font-size: 16px;
}
.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
</style>
